import { collection, getDocs } from "firebase/firestore";
import { Collections, db } from "../../utils/firebase.config";
import { converterOf } from "../../utils/firebase.utils";
import Maid from "../../entities/maid.entity";

export function useMaids() {
  const maidsCollection = collection(db, Collections.Maids).withConverter(converterOf(Maid));

  const fetchAll = async (): Promise<Maid[]> => {
    const response = await getDocs<Maid>(maidsCollection);

    return response.docs.map((maid) => maid.data());
  };

  return { fetchAll };
}

export default useMaids;
